import React from 'react';
import { Image } from 'react-bootstrap';
import styles from './scp.module.css';
import CustomButton from '../customButton';
import { Link } from 'react-router-dom';
import defaultLogo from '../../images/Logo.png';

const SameCategoryProducts = ({ sameCategoryProducts }) => {
    //console.log('SAME', sameCategoryProducts);
    // const supplierName = relatedProducts.data.supplier.data.attributes.name;

    // const products = relatedProducts.data.supplier.data.attributes.products.data;


    return(
        <div className={styles.Container}>
            <div className={styles.overskrift}>Mer fra samme kategori!</div>
            <div className={styles.container2}>
            {sameCategoryProducts.map((product) => {
                const imageUrl = product?.attributes?.image?.data?.attributes?.url || defaultLogo;
                return (
                    <div className={styles.Card} key={product.id}>
                    <Link className={styles.a} to={`/product/${product.id}`}>
                        <div className={styles.ImageContainer}>
                        <Image fluid alt={product.attributes.name} src={imageUrl} />
                        </div>
                        <p className={styles.cardName}>{product.attributes.name}</p>
                        <CustomButton 
                        label="Se mer"
                        className={styles.button}
                        />
                    </Link>
                    </div>
                );
                })}
            </div>
        </div>
    )
}

export default SameCategoryProducts;